import React, {useCallback} from "react";
import styled from "styled-components";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {SquadFlag} from "apps/DRAW_PREDICTOR/components";
import {useDispatch, useSelector} from "react-redux";
import {getSquadByPositionAndGroup} from "apps/DRAW_PREDICTOR/modules/selectors";
import {setPrediction2ForEdit} from "apps/DRAW_PREDICTOR/modules/actions";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {PredictionWrapper, GroupName, SquadName} from "./Prediction";
import SwipeWhiteIcon from "apps/DRAW_PREDICTOR/assets/images/icons/swipeWhite.svg";

interface IProps {
	group: Groups;
	position: number;
}

const SwipeIconStyled = styled.div`
	position: absolute;
	height: 32px;
	width: 32px;
	background: url(${SwipeWhiteIcon}) no-repeat center center #8a1538;
	right: 10px;
	border-radius: 50%;
`;

export const EditPrediction: React.FC<IProps> = ({group, position}) => {
	const dispatch = useDispatch();
	const selectedSquad = useSelector(getSquadByPositionAndGroup)(position, group);

	const handleAddPrediction = useCallback(() => {
		if (selectedSquad) {
			dispatch(handleModalState({showEditPickModal: true}));
			dispatch(setPrediction2ForEdit(selectedSquad.id));
		}
	}, [dispatch, selectedSquad]);

	return (
		<PredictionWrapper onClick={handleAddPrediction}>
			<GroupName>
				{group}
				{position}
			</GroupName>{" "}
			<SquadFlag selectedSquad={selectedSquad} /> <SquadName>{selectedSquad?.name}</SquadName>
			<SwipeIconStyled />
		</PredictionWrapper>
	);
};
